/**
 * @file By attaching v-t to an attribute, this directive will set attribute with translated value, leaving the text content in place
 * If attribute (arg) is not passed into directive, it will replace the text content with attribute value (binding.value)
 * If neither arguments are passed in, it will set text content with translated text
 */
import { __ } from 'bits/intl'

const t = {
  bind: (originalEl: Element, binding): void => {
    let el = originalEl

    if (binding.arg) {
      const phrase = binding.value
      const translatedPhrase = __(String(phrase).trim())
      el.setAttribute(binding.arg, translatedPhrase)
    } else {
      while (el.childElementCount > 0) {
        // If Element has children tag, we find the first innermost text content
        // This is correctly choose only the text to translate instead of
        // replacing the whole children of the element/component
        // with the bare translated text
        el = el.children[0]
      }
      const phrase = binding.value || el.textContent
      const translatedPhrase = __(String(phrase).trim())
      el.textContent = translatedPhrase
    }
  },
}

export default t
